import { startsWith } from 'lodash';

export default (e: unknown): e is TouchEvent =>
  e instanceof UIEvent && startsWith(e.type, 'touch');
